<script>
import countlyVue from '../../compat/vue-core';
import i18n from '../../../../i18n';

export default countlyVue.components.BaseComponent.extend({
  name: 'ClyMessageDialog',
  props: {
    title: { type: String, required: true },
    confirmButtonLabel: { type: String, required: false, default: i18n.tc('common.confirm') },
    dialogType: { type: String, required: false, default: 'secondary' },
  },
  computed: {
    forwardedSlots() {
      return Object.keys(this.$scopedSlots).reduce((slots, slotKey) => {
        /* eslint-disable no-param-reassign */
        slots[slotKey] = this.$scopedSlots[slotKey];
        /* eslint-enable no-param-reassign */
        return slots;
      }, {});
    },
    buttonStyle() {
      if (this.dialogType === 'success' || this.dialogType === 'secondary') {
        return this.dialogType;
      }
      return 'success';
    },
  },
  methods: {
    confirmClicked() {
      this.$emit('confirm');
    },
  },
});
</script>
<template>
  <el-dialog
    destroy-on-close
    class="cly-vue-message-dialog"
    v-bind="$attrs"
    :title="title"
    v-on="$listeners"
  >
    <template #title>
      <h3 class="color-cool-gray-100">
        {{ title }}
      </h3>
    </template>
    <template
      v-for="(_, name) in forwardedSlots"
      #[name]
    >
      <slot :name="name" />
    </template>
    <template #footer>
      <div class="cly-vue-formdialog__buttons is-single-step bu-is-justify-content-flex-end bu-is-flex">
        <el-button
          size="small"
          :type="buttonStyle"
          @click="confirmClicked"
        >
          {{ confirmButtonLabel }}
        </el-button>
      </div>
    </template>
  </el-dialog>
</template>
